// FT-098 [REQ-10a]: единственная точка, где снимается handoff-фрагмент.
//
// Вызывается ПЕРВОЙ исполняемой строкой тела main.js — до `new Rollbar` и
// `Crisp.configure`. Rollbar запоминает location.href прямо в конструкторе и
// позже уносит его в телеметрию; Crisp автозагружается на каждой странице и
// имеет доступ к location.hash. Очистки на маунте Signin.vue недостаточно.
//
// И не просто чистит, а ЗАБИРАЕТ: компоненты читают тикет отсюда, а не из
// $route.hash, которого к моменту маунта уже нет.

const PARAM = "handoff";
let captured = null;

// Разбираем вручную, а не через URLSearchParams: тот трактует `+` как пробел,
// что сломало бы подпись, если payload когда-нибудь перестанет быть ASCII-JSON.
const RE = new RegExp(`(?:^|&)${PARAM}=([^&]*)`);

function extract(hash) {
  const m = hash.match(RE);
  return m ? m[1] : null;
}

export function captureHandoffFragment(loc = window.location, hist = window.history) {
  const hash = (loc.hash || "").replace(/^#/, "");
  if (!hash) return null;

  const raw = extract(hash);
  if (raw === null) return null;

  captured = decodeURIComponent(raw);

  const rest = hash
    .split("&")
    .filter((part) => !part.startsWith(`${PARAM}=`))
    .join("&");
  // search сохраняем целиком: там email и locale, на которых держится деградация.
  const url = loc.pathname + (loc.search || "") + (rest ? `#${rest}` : "");
  hist.replaceState(hist.state, "", url);

  return captured;
}

// Одноразовый: повторный вызов вернёт null. Так тикет не переживает
// собственный обмен даже в памяти страницы.
export function takeHandoffToken() {
  const token = captured;
  captured = null;
  return token;
}
